import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { AlertMessage } from "./AlertMessage";

const SearchPanelMessage = ({
	selectedTemplate,
	listTemplateNamesResponse,
}) => {
	const { t, i18n } = useTranslation(["labels", "errors"]);
	return (
		<>
			{listTemplateNamesResponse?.templateList?.length == 0 &&
				selectedTemplate == "" ? (
				""
			) : (
				<AlertMessage
					type="info"
					className={"no-template-alert"}
					message={
						<div className="no-template-message">
							{t("COMMON.NO_TEMPLATE_MESSAGE")}
							<a href="/booking/search" className="link">
								{t("COMMON.NEW_BKG")}
							</a>
						</div>
					}
				/>
			)}
		</>
	);
};

export default SearchPanelMessage;
